/*مشاوره مسکن*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={85.245}
      height={85.245}
      viewBox="0 0 85.245 85.245"
      {...props}
    >
      <path
        data-name="Path 7484"
        d="M18.466 42.623h17.053a7.1 7.1 0 007.1-7.1v-4.361c.004-7.009-5.616-16.954-7.289-16.954H18.659c-1.674 0-7.293 9.945-7.293 16.954v4.357a7.1 7.1 0 007.1 7.104z"
        fill="#febe07"
      />
      <path
        data-name="Path 7485"
        d="M38.034 3.242l-2.97 1.484a1.041 1.041 0 01-1.3-.307l-1.882-2.51a1.042 1.042 0 00-1.57-.112l-2.469 2.468a1.04 1.04 0 01-1.57-.112l-1.684-2.245a1.042 1.042 0 00-1.57-.112L20.135 4.68a1.044 1.044 0 01-1.023.266L14.8 3.714a1.043 1.043 0 00-1.2 1.5l4.87 8.992h17.049l3.943-9.634a1.042 1.042 0 00-1.428-1.33z"
        fill="#febe07"
      />
      <path
        data-name="Path 7486"
        d="M35.519 42.623a7.1 7.1 0 007.1-7.1v-4.361c.004-7.009-5.612-16.954-7.289-16.954H18.659c-.949 0 9.036.612 14.019 8.525 3.803 6.039 2.841 19.89 2.841 19.89z"
        fill="#b18300"
      />
      <path
        data-name="Path 7487"
        d="M38.033 3.241l-2.009 1a30.493 30.493 0 01-14.2 8.057l-3.864.966.509.939h17.05l3.943-9.634a1.042 1.042 0 00-1.428-1.333z"
        fill="#b18300"
      />
      <path
        data-name="Path 7488"
        d="M46.885 2.842h14.208v39.781H46.885z"
        fill="#5aa2ff"
      />
      <path
        data-name="Path 7489"
        d="M61.092 19.891l-5.683 5.683-5.683 5.683h2.842v11.366h8.525z"
        fill="#2b67b3"
      />
      <path
        data-name="Path 7490"
        d="M38.786 19.891h-4.688v22.732h12.787V19.891z"
        fill="#5aa2ff"
      />
      <path
        data-name="Path 7491"
        d="M63.934 35.519h5.683v7.1h-5.683z"
        fill="#5aa2ff"
      />
      <path
        data-name="Path 7492"
        d="M79.146 39.781a3.925 3.925 0 00-3.511 2.169l-.335.672-4.262 8.525-9.945 4.262a5.683 5.683 0 00-5.683-5.683H34.954a38.132 38.132 0 00-22.167 7.104v21.311h33.538a36.63 36.63 0 0036.07-30.26l.617-3.492a3.925 3.925 0 00-3.866-4.608z"
        fill="#ffe5cf"
      />
      <path
        data-name="Path 7493"
        d="M75.3 31.257H58.251v11.366h5.683v-7.1h5.683v7.1H75.3z"
        fill="#cbe6fe"
      />
      <path
        data-name="Path 7494"
        d="M11.366 49.726H2.842a1.421 1.421 0 00-1.421 1.421v31.256a1.421 1.421 0 001.421 1.423h8.525a1.421 1.421 0 001.421-1.421V51.147a1.421 1.421 0 00-1.422-1.421z"
        fill="#2b67b3"
      />
      <path
        data-name="Path 7495"
        d="M78.141 31.257L66.775 19.891l-5.683 5.683-5.683 5.683z"
        fill="#b18300"
      />
      <path
        data-name="Path 7496"
        d="M42.623 19.891h4.262v22.732h-4.262z"
        fill="#2b67b3"
      />
      <path
        data-name="Path 7497"
        d="M2.842 85.245h8.525a2.844 2.844 0 002.842-2.842v-2.841h32.116a38.045 38.045 0 0037.468-31.435l.617-3.492a5.335 5.335 0 00-7.689-5.684v-6.273h1.421a1.42 1.42 0 001-2.425L67.78 18.886a1.419 1.419 0 00-2.009 0l-3.258 3.258V2.842a1.42 1.42 0 00-1.421-1.421H46.885a1.42 1.42 0 00-1.421 1.421V18.47h-5.757a23.136 23.136 0 00-2.523-4.576l3.59-8.773a2.462 2.462 0 00-3.374-3.15l-2.687 1.342-1.692-2.256a2.464 2.464 0 00-3.714-.266l-2.161 2.16-1.419-1.894a2.464 2.464 0 00-3.714-.266l-2.726 2.73-4.1-1.171a2.462 2.462 0 00-2.84 3.543l4.3 7.932c-3.016 2.725-6.7 10.381-6.7 17.339v4.357a8.533 8.533 0 008.525 8.525H73l-3 6-7.813 3.349a7.1 7.1 0 00-6.778-5.089H34.955a39.307 39.307 0 00-20.747 5.89v-3.049a2.844 2.844 0 00-2.842-2.841H2.842A2.844 2.844 0 000 51.147v31.257a2.844 2.844 0 002.842 2.842zM18.721 6.313a2.459 2.459 0 002.418-.627l2.576-2.576 1.421 1.9a2.463 2.463 0 003.712.263l2.161-2.16 1.621 2.16A2.456 2.456 0 0035.702 6l2.067-1.034-3.205 7.824h-3.85l1.813-3.627-2.542-1.275-2.448 4.9h-2.491l-1.981-4.12L20.5 9.899l1.388 2.888h-2.573l-4.039-7.459zm13.956 13.578v21.311H18.47a5.689 5.689 0 01-5.683-5.681v-4.359c0-7.605 4.707-14.7 6.054-15.533h16.092a15.308 15.308 0 011.634 2.842H34.1a1.42 1.42 0 00-1.421 1.421zm2.842 1.421h9.945v19.89h-9.945zm31.257.588l7.936 7.936H58.839zM48.306 4.263h11.366v20.723L54.4 30.252a1.42 1.42 0 001 2.425h1.43v8.525h-8.524zm11.366 28.415h14.207v8.525h-2.841v-5.682a1.42 1.42 0 00-1.421-1.421h-5.683a1.42 1.42 0 00-1.421 1.421v5.683h-2.841zm8.528 8.524h-2.845V36.94H68.2zm-33.245 9.945h20.454a4.263 4.263 0 010 8.525H32.677v2.841h22.732a7.091 7.091 0 007-6.125l9.191-3.935a1.411 1.411 0 00.712-.671l4.6-9.2a2.506 2.506 0 014.708 1.556L81 47.634a35.208 35.208 0 01-34.675 29.087H14.208V57.595a36.495 36.495 0 0120.747-6.447zm-32.113 0h8.525v31.257H2.842z"
      />
      <path data-name="Path 7498" d="M5.683 55.409h2.842v4.262H5.683z" />
      <path data-name="Path 7499" d="M51.147 7.104h1.421v2.842h-1.421z" />
      <path data-name="Path 7500" d="M55.409 7.104h1.421v2.842h-1.421z" />
      <path data-name="Path 7501" d="M51.147 12.787h1.421v2.842h-1.421z" />
      <path data-name="Path 7502" d="M55.409 12.787h1.421v2.842h-1.421z" />
      <path data-name="Path 7503" d="M51.147 18.47h1.421v2.842h-1.421z" />
      <path data-name="Path 7504" d="M55.409 18.47h1.421v2.842h-1.421z" />
      <path data-name="Path 7505" d="M38.36 24.153h1.421v2.842H38.36z" />
      <path data-name="Path 7506" d="M42.623 24.153h1.421v2.842h-1.421z" />
      <path data-name="Path 7507" d="M38.36 29.836h1.421v2.841H38.36z" />
      <path data-name="Path 7508" d="M42.623 29.836h1.421v2.841h-1.421z" />
      <path data-name="Path 7509" d="M38.36 35.519h1.421v2.842H38.36z" />
      <path data-name="Path 7510" d="M42.623 35.519h1.421v2.842h-1.421z" />
      <path data-name="Path 7511" d="M51.147 24.153h1.421v2.842h-1.421z" />
      <path data-name="Path 7512" d="M55.409 24.153h1.421v2.842h-1.421z" />
      <path
        data-name="Path 7513"
        d="M28.411 22.732h-1.417v-1.421h-2.842v1.421h-1.42a1.42 1.42 0 00-1.421 1.42v4.259a1.42 1.42 0 001.421 1.421h4.262v1.421h-5.683v1.421a1.42 1.42 0 001.421 1.421h1.421v1.421h2.842v-1.418h1.416a1.42 1.42 0 001.421-1.421v-4.266a1.42 1.42 0 00-1.421-1.417h-4.259v-1.421h5.683v-1.421a1.42 1.42 0 00-1.424-1.42z"
      />
      <path data-name="Path 7514" d="M72.458 2.842H75.3v2.842h-2.842z" />
      <path data-name="Path 7515" d="M75.3 0h2.841v2.842H75.3z" />
      <path data-name="Path 7516" d="M78.141 2.842h2.842v2.842h-2.842z" />
      <path data-name="Path 7517" d="M75.3 5.683h2.841v2.842H75.3z" />
      <path data-name="Path 7518" d="M82.404 9.945h2.841v2.842h-2.841z" />
      <path data-name="Path 7519" d="M72.458 14.208H75.3v2.842h-2.842z" />
      <path data-name="Path 7520" d="M0 12.787h2.842v2.842H0z" />
      <path data-name="Path 7521" d="M2.842 9.945h2.842v2.842H2.842z" />
      <path data-name="Path 7522" d="M5.683 12.787h2.842v2.842H5.683z" />
      <path data-name="Path 7523" d="M2.842 15.628h2.842v2.842H2.842z" />
      <path data-name="Path 7524" d="M0 24.153h2.842v2.842H0z" />
      <path data-name="Path 7525" d="M5.683 0h2.842v2.842H5.683z" />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
